import React from 'react'
import { useSelector } from 'react-redux';
import { hiddenField, paramsEdit } from '../constants/form';
import { fieldUniqueName, trimLowerCase, notUndefinedNull, fieldsUniqueNameStartsWith, getUniqueName } from '../helpers/shared';
import { getValueEdit} from '../helpers/edit';
import { addValue } from '../helpers/edit';
import { useWatch } from 'react-hook-form';
import classNames from 'classnames';
const last = {
    ordinal: 'Last',
    description_en: 'Last',
    description_es: 'Último',
    code:'last',
    separator: true
}

const useDateMonthly = (field, setValue) => {
  const { actualLanguage } = useSelector(state => state.base);
  const { [`data_${trimLowerCase(actualLanguage)}`] : { ordinal_positions, week_days, field: fields } = {} } = useSelector(state => state.staticData)
  const { action } = useSelector(state => state.tier);
  const uniqueName = `${field.unique_name}__id__${field.id}`;
  let activeOptions = ordinal_positions?.map(opt => { return {...opt, active: true} }) || []
  let shortcutOptions = activeOptions.filter(option => (['1','15'].includes(option?.code)))
  shortcutOptions.push(last)
  /* Full ordinal options */
  const fullOptions = [...shortcutOptions, ...activeOptions]
  /* Summed options */
  let summedOptions = activeOptions.slice(0,4)
  summedOptions.push(last)
  /* Names for radio buttons, in order to determine whether a radio button is checked or not */
  const firstCheckName = `${field?.unique_name}-check-1`
  const secondCheckName = `${field?.unique_name}-check-2`
  /* Names for InternalSelectors, in order to be able to programatically set their values when autocompleting */
  // Generate all 9 select names dynamically
  const selectNames = Array.from({ length: 9 }, (_, i) => `${field?.unique_name}-select-${i + 1}`);
  const [
    firstSelectName,
    secondSelectName,
    thirdSelectName,
    fourthSelectName,
    fifthSelectName,
    sixthSelectName,
    seventhSelectName,
    eighthSelectName,
    ninthSelectName
  ] = selectNames
  const parentField = fields.find(currentField => currentField.id == field.parent)
  const parentName = getUniqueName(parentField)
  let watchedParent = useWatch({ name: parentName || '' })
  let prevValue = addValue(parentField, false)

  React.useEffect(() => {
    setTimeout(() => {
      if (prevValue !== watchedParent) setValue(uniqueName, hiddenField)
    }, 400);
  }, [watchedParent])
  
  /* -------------- */
  /* These first 2 states are for the case 'pay_freqency' === 'monthly' */
  const [firstRadio, setFirstRadio] = React.useState({
    ordinal: ''
  })
  const [secondRadio, setSecondRadio] = React.useState({
    ordinal: '',
    weekDay: ''
  })
  /* 'Bimonthly'/'Twice per month' escenario */
  const [thirdRadio, setThirdRadio] = React.useState({
    firstOrdinal: '',
    secondOrdinal: ''
  })
  const [fourthRadio, setFourthRadio] = React.useState({
    firstOrdinal: '',
    firstWeekday: '',
    secondOrdinal: '',
    secondWeekday: ''
  })

  let value = useWatch({name: uniqueName || ''}) 

  // Manually reset the internal state for the 'radio' fields
  // thats composed using the 'InternalSelector' component
  React.useEffect(() => {
    if (value === hiddenField) {
      setFirstRadio({ordinal: ''})
      setSecondRadio({ordinal: '', weekDay: ''})
      setThirdRadio({ firstOrdinal: '', secondOrdinal: '' })
      setFourthRadio({ firstOrdinal: '', firstWeekday: '', secondOrdinal: '', secondWeekday: '' })
    }
  }, [value])

  // Reseting all of the internal selectors back to its original first 'option'
  // whevener their 'radio' parent's value is 'hiddenValue'
  React.useEffect(() => {
    const selects = document.querySelectorAll('.resettable-select');
    if (selects?.length && (value === hiddenField || value === 'date-1' || value === 'date-2')){
      selects.forEach((select) => {
        select.selectedIndex = 0
      })
    }
  }, [value])

  /* State in order  to be used to create the classNames dinamically */
  const [firstCheckDisabled, setFirstCheckDisabled] = React.useState(null)
  const [secondCheckDisabled, setSecondCheckDisabled] = React.useState(null)
  /* useEffect to be used to create the classNames dinamically */
  let firstCheckElement = fieldUniqueName(firstCheckName)
  let secondCheckElement = fieldUniqueName(secondCheckName)
  React.useEffect(() => {
    setFirstCheckDisabled(!firstCheckElement?.checked)
    setSecondCheckDisabled(!secondCheckElement?.checked)
  }, [value])
  /* Dinamyc classNames */
  let firstLabelClassNames = classNames('d-flex align-items-center gap-2', {
    'text-muted': firstCheckDisabled
  })
  let secondLabelClassNames = classNames('d-flex align-items-center gap-2', {
    'text-muted': secondCheckDisabled
  })

  let functionGetValues = (notUndefinedNull(field.function_get_values)) ? JSON.parse(field.function_get_values) : null;
  const storageData = (field?.storage_data_key) ? JSON.parse(
    field.storage_data_key) : null;
    
  const types = {
    monthly: 'monthly',
    bimonthly: 'twice_per_month'
  }

  const setSelect = (id, val) => {
    let element = document?.getElementById(id)
    if (element) element.value = val
  }
    
  /* useEffect for autocompleting the component */
  let timeForAutocomplete = (action === paramsEdit) ? 20500 : 12500
  React.useEffect(() => {
    let prevValue;
    setTimeout(() => {
      if (notUndefinedNull(storageData)) {
        if (storageData?.type !== 'default') {
          const parentCondition = (field?.parent_condition) ? JSON.parse(field.parent_condition) : null;
          prevValue = getValueEdit(field);
          let parent = document.getElementById(field?.parent)
          if (parent) { 
            let parentsSelectedOption = Array.from(parent?.options).filter(option => option?.id == parent?.value)[0]
            let parentSelectedType = parentsSelectedOption?.dataset?.code
            let isType = parentCondition?.value[0] === parentSelectedType
            let checkBoxes = fieldsUniqueNameStartsWith(`${field?.unique_name}-check-`)
            prevValue = prevValue.replace('-1', 'last')
            if (parentSelectedType === types?.monthly) { 
              if (!prevValue?.includes(',')) {
                setFirstRadio({
                  ordinal: prevValue
                })
                setTimeout(() => {
                  checkBoxes[0].click()
                  setFirstCheckDisabled(false)
                  setSecondCheckDisabled(true)
                  setSelect(firstSelectName, prevValue)
                }, 100);
              } else {
                
                const [ordinal, weekDay] = prevValue?.split(',')
                setSecondRadio({
                  ordinal,
                  weekDay
                })
                setTimeout(() => {
                  checkBoxes[1].click()
                  setFirstCheckDisabled(true)
                  setSecondCheckDisabled(false)
                  setSelect(secondSelectName, ordinal)
                  setSelect(thirdSelectName, weekDay)
                }, 100);
              }
            }
            if (parentSelectedType === types?.bimonthly) {
              if (!prevValue?.includes(',')) {
               
                const [day1, day2] = prevValue?.split('&')
                setThirdRadio({
                  firstOrdinal: day1,
                  secondOrdinal: day2
                })
                setTimeout(() => {
                  checkBoxes[0].click()
                  setFirstCheckDisabled(false)
                  setSecondCheckDisabled(true)
                  setSelect(fourthSelectName, day1)
                  setSelect(fifthSelectName, day2)
                }, 100);
              }
              if (prevValue?.includes(',')) {
     
                const [firstDate, secondDate] = prevValue?.split('&')
                const [firstOrdinal, firstWeekday] = firstDate?.split(',') 
                const [secondOrdinal, secondWeekday] = secondDate?.split(',')
                setFourthRadio({
                  firstOrdinal, firstWeekday,
                  secondOrdinal, secondWeekday
                })
                setTimeout(() => {
                  checkBoxes[1].click()
                  setFirstCheckDisabled(true)
                  setSecondCheckDisabled(false)
                  setSelect(sixthSelectName, firstOrdinal)
                  setSelect(seventhSelectName, firstWeekday)
                  setSelect(eighthSelectName, secondOrdinal)
                  setSelect(ninthSelectName, secondWeekday)
                }, 100);
              }
            }
            if (isType) {
              setValue(getUniqueName(field), prevValue)
            } 
          }
        }
      }
    }, timeForAutocomplete);
  }, [field, action])

  /* Functions for setting final values in radio button 
  ** according to values in their Internal Selector
  */
  const calculateFirstVal = () => {
    if (functionGetValues?.type === 'monthly'){
      return firstRadio?.ordinal || 'date-1'
    }
    if (functionGetValues?.type === 'bimonthly') {
      if (!thirdRadio?.firstOrdinal && !thirdRadio?.secondOrdinal){
        return 'date-1'
      }
      return `${thirdRadio?.firstOrdinal}&${thirdRadio?.secondOrdinal}`
    }
  }
  const calculateSecondVal = () => {
    if (functionGetValues?.type === 'monthly'){
      if (!secondRadio?.ordinal && !secondRadio?.weekDay){
        return 'date-2'
      }
      return `${secondRadio?.ordinal},${secondRadio?.weekDay}`
    } 

    if (functionGetValues?.type === 'bimonthly') {
      if (!fourthRadio?.firstOrdinal && !fourthRadio?.firstWeekday && !fourthRadio?.secondOrdinal && !fourthRadio?.secondWeekday){
        return 'date-2'
      }
      return `${fourthRadio?.firstOrdinal},${fourthRadio?.firstWeekday}&${fourthRadio?.secondOrdinal},${fourthRadio?.secondWeekday}`
    }

  }

  /* Function for creating and setting the final value to the parentCheck field */
  const internalSetValue = (name, value, checkNumber) => {
    value = (trimLowerCase(value) === 'last') ? -1 : value
    let res
    /* These first 3 'if' statements are for 3 InternalSelector
    **  for case 'pay_frequency' === 'monthly' */
    //* First radio
    if (checkNumber === 1) {
      setFirstRadio((prev) => {return {...prev, ordinal: value}})
      res = value
      setValue(name, value)
    }
    //* Second radio
    if (checkNumber === 2) {
      setSecondRadio((prev) => {return {...prev, ordinal: value}})
      res = `${value},${secondRadio?.weekDay}`
      setValue(name, res)
    }
    if (checkNumber === 3) {
      setSecondRadio((prev) => {return {...prev, weekDay: value}})
      res = `${secondRadio?.ordinal},${value}`
      setValue(name, res)
    }
    /* while these are for the 'bimonthly'/'twice per month' escenario */
    //* Third radio
    if (checkNumber === 4) {
      setThirdRadio(prev => { return {...prev, firstOrdinal: value} })
      res = `${value}&${thirdRadio?.secondOrdinal}`
      setValue(name, res)
    }
    if (checkNumber === 5) {
      setThirdRadio(prev => { return {...prev, secondOrdinal: value} })
      res = `${thirdRadio?.firstOrdinal}&${value}`
      setValue(name, res)
    }
    //* Fourth radio
    if (checkNumber === 6){
      setFourthRadio(prev => { return { ...prev, firstOrdinal: value } })
      res = `${value},${fourthRadio?.firstWeekday}&${fourthRadio.secondOrdinal},${fourthRadio.secondWeekday}`
      setValue(name, res)
    }
    if (checkNumber === 7){
      setFourthRadio(prev => { return { ...prev, firstWeekday: value } })
      res = `${fourthRadio.firstOrdinal},${value}&${fourthRadio.secondOrdinal},${fourthRadio.secondWeekday}`
      setValue(name, res)
    }
    if (checkNumber === 8){
      setFourthRadio(prev => { return { ...prev, secondOrdinal: value } })
      res = `${fourthRadio.firstOrdinal},${fourthRadio.firstWeekday}&${value},${fourthRadio.secondWeekday}`
      setValue(name, res)
    }
    if (checkNumber === 9){
      setFourthRadio(prev => { return { ...prev, secondWeekday: value } })
      res = `${fourthRadio.firstOrdinal},${fourthRadio.firstWeekday}&${fourthRadio.secondOrdinal},${value}`
      setValue(name, res)
    }

    return res
  }


  return {
    fullOptions,
    summedOptions, 
    week_days,
    calculateFirstVal,
    calculateSecondVal,
    internalSetValue,
    firstLabelClassNames,
    secondLabelClassNames,
    firstCheckName,
    secondCheckName,
    firstCheckSelected: !firstCheckDisabled,
    secondCheckSelected: !secondCheckDisabled,
    functionGetValues,
    selectNames
  }
}

export default useDateMonthly